<template>
  <div>
    <div class="mb-3">
      Applicable to both Guarantor and borrowing Entity
    </div>
    <vue-form-generator
      ref="form"
      :schema="schema"
      :model="model"
      :options="formOptions"
    />
    <wizard-verified-submit-button
      text="Update Declarations Data"
      @submit="submit"
    />
  </div>
</template>

<script>
import VueFormGenerator from 'vue-form-generator';
import WizardVerifiedSubmitButton from '@/components/utils/buttons/form/WizardVerifiedSubmitButton';

import schemaDefinition from '@/components/profile/sections/tabs/declarations/schema';

import helper from '@/libs/helper';
import { DEFINE_PROFILE_DECLARATIONS } from '@/vuex/modules/profile/types/actions';
import { DEMOGRAPHICS_TAB } from '@/components/profile/sections/tabs/tabNumbers';

export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    WizardVerifiedSubmitButton,
  },
  data() {
    return {
      model: {},
      schema: schemaDefinition.schema,
      formOptions: schemaDefinition.formOptions,
      DEMOGRAPHICS_TAB,
    };
  },
  methods: {
    isValid() {
      return this.$refs.form.validate();
    },
    clearValidationErrors() {
      return this.$refs.form.clearValidationErrors();
    },
    submit(moveTab) {
      if (!this.isValid()) {
        return;
      }
      if (this.model.bankrupt === false) {
        this.model.bankruptDischarged = null;
      }

      this.$reqs
        .post(
          `/users/${this.$store.getters.user.id}/profile/declarations`,
          this.model,
        )
        .then((response) => {
          this.$store.dispatch(DEFINE_PROFILE_DECLARATIONS, {
            declarations: response.data.declarations,
          });
          this.$emit('tab-info-updated', 'Background Information');
          if (moveTab) {
            this.$emit('move-to-next-tab', DEMOGRAPHICS_TAB);
          }
        })
        .catch(() => {});
    },
  },
  created() {
    const profile = this.$store.getters.profile;
    if (profile && profile.declarations) {
      this.model = helper.copy(profile.declarations);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/declarations/DeclarationsContent.vue